<template>
  <div class="main-content-container">
    <div class="container" style="max-width: 90% !important">
      <!-- Page Header -->
      <div class="page-header row no-gutters py-4">
        <div class="col-6 text-center text-sm-left mb-0">
          <span class="text-uppercase page-subtitle">sessão</span>
          <h3 class="page-title">Maquininhas</h3>
        </div>
        <!-- Page Header - Filters -->
        <div class="col-6 d-flex">
          <div class="input-group d-flex justify-content-end my-auto">
            <button type="button" class="btn btn-primary btn-sm mt-3" @click="OpenModalFilter()">
              <i class="fas fa-filter"></i>
              {{ countFilter > 0 ? "Filtros aplicados" : "" }}
              <span v-if="countFilter > 0" class="badge badge-light">{{ countFilter }}</span>
            </button>
            <button v-if="countFilter > 0" type="button" class="input-group-text btn-sm ml-1 mt-3"
              v-b-tooltip.hover.bottom title="Limpar filtros" @click="ResetFilter()">
              <i class="fas fa-eraser"></i>
            </button>
          </div>
        </div>
      </div>

      <!-- Default Light Table -->
      <div class="row">
        <div class="col">
          <div class="card card-small mb-4" style="width: 105%;">
            <div class="card-header border-bottom">
              <div class="float-left">
                <h6 class="m-0">Clientes</h6>
              </div>
              <div v-if="pagination.TotalItems > 0" class="float-right">
                <b-input-group class="d-flex justify-content-end my-auto ml-2">
                  <h6 v-if="pagination.TotalItems > 0" class="m-0">
                    {{ pagination.TotalItems | number }}
                    {{ pagination.TotalItems > 1 ? " itens" : "item" }}
                  </h6>
                  <div class="dropdown m-0" v-if="pagination.TotalItems > 1">
                    <button class="btn btn-outline-secondary dropdown-toggle-ellipsis" type="button"
                      v-b-tooltip.hover.right title="Mais opções" id="dropdownMenuButton" data-toggle="dropdown"
                      aria-haspopup="true" aria-expanded="false">
                      <i class="fas fa-ellipsis-v"></i>
                    </button>
                  </div>
                </b-input-group>
              </div>
            </div>
            <div class="card-body p-0 pb-3 text-center">
              <loader :is-loading="loadingList"></loader>
              <table class="table mb-0" v-if="!loadingList">
                <thead class="bg-s2p-gray-light">
                  <tr>
                    <th scope="col" class="border-0">Cliente</th>
                    <th scope="col" class="border-0">Id MerchantMaquina / Maquininha</th>
                    <th scope="col" class="border-0">Rótulo/Identificador</th>
                    <th scope="col" class="border-0">Modelo</th>
                    <th scope="col" class="border-0">Número Série</th>
                    <th scope="col" class="border-0">Início Operação</th>
                    <th scope="col" class="border-0">Fim Operação</th>
                    <th scope="col" class="border-0">Conta/Token</th>
                    <th scope="col" class="border-0">Captura</th>
                    <th scope="col" class="border-0">Situação</th>
                    <th scope="col" class="border-0"></th>
                  </tr>
                </thead>
                <tbody>
                  <tr v-for="(merchantMaquina, index) in listaMerchantMaquina" :key="index">
                    <td class="text">
                      {{ merchantMaquina.Merchant.Id }} - 
                      {{ merchantMaquina.Merchant.Name }}
                      <br />
                      {{ merchantMaquina.Merchant.Identity | identity }}
                    </td>
                    <td class="text">
                      {{ merchantMaquina.Id }} / {{ merchantMaquina.Maquina.Id }}
                    </td>
                    <td class="text">
                      {{ merchantMaquina.Rotulo }}
                      <br />
                      {{ merchantMaquina.IdentificadorTerminal }}
                    </td>
                    <td class="text">
                      {{ merchantMaquina.Maquina.MaquinaModelo.MaquinaFabricante.Nome }}
                      <br />
                      {{ merchantMaquina.Maquina.MaquinaModelo.Nome }}
                    </td>
                    <td class="text">{{ merchantMaquina.Maquina.NumeroSerie }}</td>
                    <td class="text"  v-if="merchantMaquina.DataInicioOperacao == null">
                        -  
                    </td>
                    <td class="text" v-else >{{ merchantMaquina.DataInicioOperacao | date }}</td>

                    <td class="text" v-if="merchantMaquina.DataFimOperacao == null">
                      - 
                    </td>
                    <td class="text" v-else> {{ merchantMaquina.DataFimOperacao | date }}</td>
                    <td class="text" v-if="merchantMaquina.IdConta != null">
                      {{ merchantMaquina.IdConta }}
                      <br />
                      {{ merchantMaquina.IdEmpresa }} {{ merchantMaquina.IdLoja }} {{ merchantMaquina.IdTerminal }}
                    </td>
                    <td class="text" v-else>
                      -
                    </td>
                    <td class="text" v-if="merchantMaquina.ModeloCaptura != null">
                      {{ merchantMaquina.ModeloCaptura.Id }} - {{ merchantMaquina.ModeloCaptura.Nome }}
                    </td>
                    <td class="text" v-else>
                      -
                    </td>
                    <td class="text" >
                     <span :class="[BuscarClassSituacao(merchantMaquina.Situacao)]">
                      {{
                        merchantMaquina.Situacao.Nome
                      }}
                     </span>
                    </td>
                    <td class="text">
                       <div class="dropdown">
                        <button class="btn btn-outline-secondary dropdown-toggle" type="button" id="dropdownMenuButton"
                          data-toggle="dropdown" aria-haspopup="true" aria-expanded="false"
                          :title="IsAuthorizedShow() ? 'Opções' : 'Você não possui permissão'"
                          :disabled="!IsAuthorizedShow()">
                          Opções
                        </button>
                        <div class="dropdown-menu" aria-labelledby="dropdownMenuButton">
                      <a v-if="
                              $isAuthorize('MerchantMaquina', 'Update') 
                          " class="dropdown-item" href="#" v-on:click="EditarMerchantMaquina($event, merchantMaquina.Id)">
                            <i class="fas fa-highlighter mr-2"></i> Editar
                      </a>
                      <a
                            v-if="
                              $isAuthorize('MerchantMaquina', 'Update') && LiberarBotaoAbrirPdf(merchantMaquina)
                            "
                            class="dropdown-item"
                            href="#"
                            v-on:click="DownloadPdf(merchantMaquina)"
                          >
                            <i class="fas fa-check mr-2"></i> Download Pdf
                          </a>
                         
                      </div>
                      </div>
                    </td>
                  </tr>
                  <tr v-if="listaMerchantMaquina == undefined ||
                    listaMerchantMaquina == null ||
                    listaMerchantMaquina.length == 0
                    ">
                    <td colspan="8">Sem registros</td>
                  </tr>
                </tbody>
              </table>

              <div class="col-12 border-top">
                <div class="pagination-nav">
                  <b-pagination class="float-right" v-model="pagination.PageNumber" :total-rows="pagination.TotalItems"
                    :per-page="pagination.RowsPerPage" aria-controls="my-table"></b-pagination>
                  <div class="float-left">
                    <d-select size="sm" v-model="pagination.RowsPerPage">
                      <option value="5">5</option>
                      <option value="10">10</option>
                      <option value="30">30</option>
                      <option value="50">50</option>
                      <option value="100">100</option>
                      <option value="200">200</option>
                      <option value="500">500</option>
                    </d-select>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <b-modal id="mFilter" title="Filtros" centered :no-close-on-backdrop="true" :no-close-on-esc="false">
      <d-form-row>
        <d-col md="6" class="form-group">
          <input :placeholder="'Id Merchant'" type="text" class="form-control" v-model="filter.IdMerchant" />
        </d-col>
        <d-col md="6" class="form-group">
          <the-mask :placeholder="'Documento Merchant'" class="form-control" type="tel"
            :mask="['###.###.###-##', '##.###.###/####-##']" v-model="filter.DocumentoMerchant" />
        </d-col>
        <d-col md="12" class="form-group">
          <input :placeholder="'Nome Merchant'" type="text" class="form-control" v-model="filter.NomeMerchant" />
        </d-col>
        <d-col md="12" class="form-group">
          <label>Situação</label>
          <d-select v-model="filter.IdSituacao" :value="null">
            <option :value="null" selected>Selecione</option>
            <option :value="1">Aguardando Assinatura</option>
            <option :value="2">Em Preparação</option>
            <option :value="3">Em Trânsito</option>
            <option :value="4">Operacional</option>   
            <option :value="5">Devolvida</option>
          </d-select>
        </d-col>
        <d-col md="6" class="form-group">
          <input :placeholder="'Id Maquininha'" type="text" class="form-control" v-model="filter.IdMaquininha" />
        </d-col>
        <d-col md="6" class="form-group">
          <input :placeholder="'Empresa'" type="text" class="form-control" maxlength="6" v-model="filter.IdEmpresa" />
        </d-col>
        <d-col md="6" class="form-group">
          <input :placeholder="'Loja'" type="text" class="form-control" maxlength="4" v-model="filter.IdLoja" />
        </d-col>
        <d-col md="6" class="form-group">
          <input :placeholder="'Terminal'" type="text" class="form-control" maxlength="2" v-model="filter.IdTerminal" />
        </d-col>

        <d-col md="6" class="form-group">
          <input :placeholder="'Código Patrimônio'" type="text" class="form-control"
            v-model="filter.CodigoPatrimonioMaquina" />
        </d-col>
        <d-col md="6" class="form-group">
          <input :placeholder="'Numero Série'" type="text" class="form-control" v-model="filter.NumeroSerieMaquina" />
        </d-col>
      </d-form-row>

      <template slot="modal-footer">
        <b-button variant="primary" class="btn btn-primary" v-b-tooltip.hover.bottom title="Pesquisar" @click="Filter()">
          <i class="fas fa-search"></i>
        </b-button>
        <b-button variant="primary" class="input-group-text" v-b-tooltip.hover.bottom title="Limpar filtros"
          @click="ResetFilter()">
          <i class="fas fa-eraser"></i>
        </b-button>
      </template>
    </b-modal>

    <b-modal id="mVisualizarMerchantMaquina" title="Visualização do vínculo entre máquina e merchant" size="lg" centered
      :no-close-on-backdrop="true" :no-close-on-esc="false">
      <!-- Loader -->
      <div v-if="loadingModalVisualizarMerchantMaquina">
        <loader :is-loading="loadingModalVisualizarMerchantMaquina"></loader>
      </div>
      <div v-else>
        <ValidationObserver tag="form" ref="MerchantMaquinaForm">
          <div v-html="BuscarTitleVisualizarMaquinaMerchant()"></div>
          <d-form-row>
            <d-col md="6" class="form-group">
              <label>Início da Operação</label>
              <ValidationProvider rules="required" v-slot="{ errors, invalid }">
                <date-field v-model="merchantMaquinaSelecionado.DataInicioOperacao"
                  :maxDate="merchantMaquinaSelecionado.DataFimOperacao"
                  v-bind:inputClass="validateMerchantMaquina | showValidateError(invalid)" :disabled="merchantMaquinaSelecionado.DataInicioOperacao != null &&
                    merchantMaquinaSelecionado.UsuarioAtivacaoOperacao.Id > 0
                    " />
                <div class="invalid-feedback d-block" v-if="validateMerchantMaquina">
                  {{ errors[0] }}
                </div>
              </ValidationProvider>
            </d-col>

            <d-col md="6" class="form-group" v-if="merchantMaquinaSelecionado.UsuarioAtivacaoOperacao != null &&
              merchantMaquinaSelecionado.UsuarioAtivacaoOperacao.Id > 0
              ">
              <label>Fim da Operação</label>
              <ValidationProvider rules="required" v-slot="{ errors, invalid }">
                <date-field v-model="merchantMaquinaSelecionado.DataFimOperacao"
                  :minDate="merchantMaquinaSelecionado.DataInicioOperacao"
                  v-bind:inputClass="validateMerchantMaquina | showValidateError(invalid)" />
                <div class="invalid-feedback d-block" v-if="validateMerchantMaquina">
                  {{ errors[0] }}
                </div>
              </ValidationProvider>
            </d-col>
          </d-form-row>

          <d-form-row>
            <d-col md="12" class="form-group">
              <label>Observação</label>
              <!-- <ValidationProvider rules="required|min:15|max:1000" v-slot="{ errors, invalid }"> -->
              <b-form-textarea type="text" rows="4" v-model="merchantMaquinaSelecionado.Observacao" />
              <!--  <div class="invalid-feedback d-block" v-if="validateMerchantMaquina">
                  {{ errors[0] }}
                </div>
              </ValidationProvider> -->
            </d-col>
          </d-form-row>
        </ValidationObserver>
      </div>
      <template slot="modal-footer" slot-scope="{ cancel }">
        <b-button size="sm" @click="cancel()">Fechar</b-button>
        <b-button v-if="true" size="sm" :variant="merchantMaquinaSelecionado.UsuarioAtivacaoOperacao != null &&
          merchantMaquinaSelecionado.UsuarioAtivacaoOperacao.Id > 0
          ? 'danger'
          : 'success'
          " @click="AtualizarMerchantMaquina()" :disabled="loadingModalVisualizarMerchantMaquina">
          <template v-if="!loadingModalVisualizarMerchantMaquina">
            {{
              merchantMaquinaSelecionado.UsuarioAtivacaoOperacao != null &&
              merchantMaquinaSelecionado.UsuarioAtivacaoOperacao.Id > 0
              ? "Finalizar Operação"
              : "Iniciar Operação"
            }}
            <i class="fas fa-arrow-right"></i>
          </template>
          <template v-else>
            <loader :small="true" :isLoading="loadingModalVisualizarAlerta"></loader>
          </template>
        </b-button>
      </template>
    </b-modal>

    <b-modal size="lg" id="mFormMerchantMaquina" :title="modalTitle" :no-close-on-backdrop="true"
      :no-close-on-esc="false">
      <!-- Loader -->
      <div v-if="loadingModal">
        <loader :is-loading="loadingModal"></loader>
      </div>
      <div v-else>
        <!-- Modelo -->
        <ValidationObserver tag="form" ref="validateMerchantMaquinaForm">
          <d-form-row>
            <d-col md="2">
              <label>IdMerchant</label>
              <input placeholder="Id Merchant" type="text" class="form-control" v-model="infoMerchantMaquina.Merchant.Id"
                v-on:keyup.enter="BuscarMerchant()" v-on:blur="BuscarMerchant()" />
            </d-col>
            <d-col md="4" class="form-group">
              <label>Documento Merchant</label>
              <the-mask :placeholder="'Documento Merchant'" class="form-control" type="tel"
                :mask="['###.###.###-##', '##.###.###/####-##']" v-model="infoMerchantMaquina.Merchant.Documento"
                disabled />
            </d-col>
            <d-col md="6">
              <label>Nome Merchant</label>
              <input placeholder="Nome Merchant" type="text" class="form-control"
                v-model="infoMerchantMaquina.Merchant.Nome" disabled />
            </d-col>

          </d-form-row>

          <d-form-row v-if="showInputsMargemLucro">
            <d-col md="4" class="form-group">
              <label>Margem de Lucro no Crédito</label>
              <decimal-field class="form-control" v-model="infoMerchantMaquina.MargemLucroCredito" type="percentage"
                :maxDecimalPlaces="0" />
            </d-col>

            <d-col md="4" class="form-group">
              <label>Margem de Lucro no Débito</label>
              <decimal-field class="form-control" v-model="infoMerchantMaquina.MargemLucroDebito" type="percentage"
                :maxDecimalPlaces="0" />
            </d-col>

            <d-col md="4" class="form-group">
              <label>É antecipado</label>
              <ValidationProvider rules="required" v-slot="{ errors, invalid }">
                <d-select v-model="infoMerchantMaquina.EhAntecipado"
                  :class="validateMerchantMaquinaForm | showValidateError(invalid)" :value="null">
                  <option :value="false" selected>Não</option>
                  <option :value="true">Sim</option>

                </d-select>
                <div class="invalid-feedback d-block" v-if="validateMerchantMaquinaForm">
                  {{ errors[0] }}
                </div>
              </ValidationProvider>
            </d-col>

          </d-form-row>
          <d-form-row>
            <d-col md="4">
              <label>Quantidade de Máquinas</label>
              <input placeholder="Qtd de máquinas" type="number" class="form-control" min="0"
                v-model="infoMerchantMaquina.QuantidadeMaquinas" />
            </d-col>

            <d-col md="4" class="form-group">
              <label>Modelo Captura</label>
              <ValidationProvider rules="required" v-slot="{ errors, invalid }">
                <d-select v-model="infoMerchantMaquina.ModeloCaptura"
                  :class="validateMerchantMaquinaForm | showValidateError(invalid)" :value="null">
                  <option :value="1" selected>Stand-alone</option>
                  <option :value="2">Integração API</option>
                  <option :value="3">Integração local</option>
                </d-select>
                <div class="invalid-feedback d-block" v-if="validateMerchantMaquinaForm">
                  {{ errors[0] }}
                </div>
              </ValidationProvider>
            </d-col>
                        <d-col v-if="isPfSubaccount" md="4" class="form-group">
              <label style="color:red;">Aviso</label>
                <div style="margin-left:5%;font-size: 12px;color:red;">* Não é permitido fazer reserva de máquinas para subcontas de tipo Pessoa Física.
                </div>
            </d-col>

            <d-col md="8" class="form-group">
              <div v-if="isSubaccount && !isPfSubaccount">
                <label>Envio de Máquina</label>
                <ValidationProvider rules="required" v-slot="{ errors, invalid }">
                  <d-form-row>
                    <d-form-radio v-model="DeveBuscarEnderecoMkt" 
                    :value="true" :disabled="isSeeing">
                      Endereço do Marketplace
                    </d-form-radio>
                    <d-form-row>
                    </d-form-row>
                    <d-form-radio v-model="DeveBuscarEnderecoMkt" 
                    :value="false" :disabled="isSeeing" style="margin-left: 20px;">
                      Endereço da Subconta
                    </d-form-radio>
                  </d-form-row>
                </ValidationProvider>
              </div>
            </d-col>

            <d-col v-if="isSubaccount && !isPfSubaccount" md="4" class="form-group">
              <label style="color:red;">Aviso</label>
                <div style="margin-left:5%;font-size: 12px;color:red;">* O onboarding na Payer será feito automaticamente com os dados de cadastro da Subconta, o contrato será enviado para assinatura do Marketplace, e a máquina enviada ao endereço selecionado.
                </div>
            </d-col>

          </d-form-row>
        </ValidationObserver>
      </div>

      <template slot="modal-footer" slot-scope="{ cancel }">
        <!-- Emulate built in modal footer ok and cancel button actions -->
        <b-button size="sm" @click="cancel()">Fechar</b-button>
        <b-button size="sm" variant="success" @click="SaveNewMerchantMaquina()" :disabled="loadingAddUpdate">
          <template v-if="!loadingAddUpdate">
            {{ " Reservar" }}
            <i class="fas fa-arrow-right"></i>
          </template>
          <template v-else>
            <loader :small="true" :isLoading="loadingAddUpdate"></loader>
          </template>
        </b-button>
      </template>
    </b-modal>

    <b-modal size="md" id="mFormEditarMaquininha" :title="`Editar ${merchantMaquinaClone.Rotulo} - ${ merchantMaquinaClone.IdConta } ${ merchantMaquinaClone.IdEmpresa } ${ merchantMaquinaClone.IdLoja } ${ merchantMaquinaClone.IdTerminal }`"  :no-close-on-backdrop="true"
    :no-close-on-esc="false">
    <!-- Loader -->
    <div v-if="loadingModal">
      <loader :is-loading="loadingModal"></loader>
    </div>
    <div v-else>
      <!-- Modelo -->
      <ValidationObserver tag="form" ref="validateFormEditarMaquininha">
        <d-form-row>
            <p>Você tem certeza que deseja editar a maquininha <b>{{merchantMaquinaClone.Rotulo}} - {{ merchantMaquinaClone.IdConta }} {{ merchantMaquinaClone.IdEmpresa }} {{ merchantMaquinaClone.IdLoja }} {{ merchantMaquinaClone.IdTerminal }}</b></p>
         <d-col md="7" class="form-group">
            <label>Usuário</label>
            <d-form-input type="text" v-model="$getUserInternal().Name" readonly />
          </d-col>

          <d-col md="5" class="form-group">
            <label>Data</label>
            <d-form-input
              type="text"
              v-bind:value="new Date() | date('DD/MM/YYYY - HH:mm')"
              readonly
            />
          </d-col>
          <d-col md="12">
            <label>Motivo da Edição</label>
             <ValidationProvider
              rules="required|min:15"
              v-slot="{ errors, invalid }"
            >
                <b-form-textarea
                  type="text"
                  rows="4"
                  v-model="merchantMaquinaClone.Motivo"
                  :class="MerchantMaquinaForm | showValidateError(invalid)"
                /> 
            <div
                class="invalid-feedback d-block"
                v-if="MerchantMaquinaForm"
              >
                {{ errors[0] }}
              </div>
              </ValidationProvider>
          </d-col>
          
          <d-col md="12" class="form-group" >
            <br>
            <label>Selecione a situação do vinculo entre merchant e máquina</label>
              <ValidationProvider rules="required"
                  v-slot="{ errors, invalid }">
                <d-select :class="MerchantMaquinaForm | showValidateError(invalid)"
                v-model="merchantMaquinaClone.Situacao.Id">
                <option :value="null" selected>Selecione</option>
                <option :value="1">Aguardando Assinatura</option>
                <option :value="2">Em Preparação</option>
                <option :value="3">Em Trânsito</option>
                <option :value="4">Operacional</option> 
                <option :value="6">Em Devolução</option>     
                <option :value="5">Devolvida</option>
                </d-select>
                <div class="invalid-feedback d-block"
                     v-if="MerchantMaquinaForm">
                  {{ errors[0] }}
                </div>
              </ValidationProvider>
          </d-col>
          <d-col md="12" class="form-group">

            <label>Selecione a situação da Maquina</label>
              <ValidationProvider rules="required"
                  v-slot="{ errors, invalid }">
                <d-select :class="MerchantMaquinaForm | showValidateError(invalid)"
                v-model="merchantMaquinaClone.Maquina.Situacao.Id">
                <option :value="null" selected>Selecione</option>
                <option :value="1">Estoque</option>
                <option :value="2">Instalada</option>
                <option :value="3">Transporte</option>
                <option :value="4">Manutenção</option>
                <option :value="5">Reservada</option>   
                </d-select>
                <div class="invalid-feedback d-block"
                     v-if="MerchantMaquinaForm">
                  {{ errors[0] }}
                </div>
              </ValidationProvider>
          </d-col>
          <d-col md="6" class="form-group">
            <label>Data Inicio da Operação</label>
            <date-field 
            v-model="merchantMaquinaClone.DataInicioOperacao" minimumView="day"
            ></date-field>
          </d-col>
          <d-col md="6" class="form-group">
            <label>Data Fim da Operação</label>
            <date-field
              v-model="merchantMaquinaClone.DataFimOperacao"
              format="dd/MM/yyyy"
              minimumView="day"
              :minDate="merchantMaquinaClone.DataInicioOperacao"
            ></date-field>
          </d-col>
        </d-form-row>
      </ValidationObserver>
    </div>

    <template slot="modal-footer" slot-scope="{ cancel }">
      <!-- Emulate built in modal footer ok and cancel button actions -->
      <b-button size="sm" @click="cancel()">Fechar</b-button>
      <b-button size="sm" variant="success" @click="SalvarEditarMerchantMaquina(merchantMaquinaClone)" :disabled="loadingModal">
        <template v-if="!loadingModal">
          {{ "Salvar" }}
          <i class="fas fa-arrow-right"></i>
        </template>
        <template v-else>
          <loader :small="true" :isLoading="loadingModal"></loader>
        </template>
      </b-button>
    </template>
  </b-modal>

    <a v-if="$isAuthorize('MerchantMaquina', 'Update')" href="#" class="btn-float success" v-b-tooltip.hover
      title="Res Merchant" v-on:click="OpenMerchantMaquina($event)">
      <i class="fa fa-plus"></i>
    </a>
  </div>
</template>

<script>
import decimalField from "../../common/decimal-field.vue";
import { hasValue } from "../../../utils/functions.js";
import dateField from "../../common/date-field";
export default {
  name: "deals-merchantmaquina",
  components: {
    dateField,
    decimalField
  },
  data: function () {
    return {
      loadingAddUpdate: false,
      showInputsMargemLucro: false,
      countFilter: 0,
      modalTitle: "Reservar máquinas",
      filter: {
        IdMerchant: null,
        NomeMerchant: null,
        DocumentoMerchant: null,
        CodigoPatrimonioMaquina: null,
        NumeroSerieMaquina: null,
        IdSituacao: null, 
        IdTerminal: null,
        IdLoja : null,
        IdEmpresa: null, 
        IdMaquininha: null
      },
      IdMerchantMaquina: null,
      infoMerchantMaquina: {
        Merchant: {
          Id: null
        },
        MargemLucroCredito: 0,
        MargemLucroDebito: 0,
        QuantidadeMaquinas: null,
        EhAntecipado: false,
        ModeloCaptura: 1,
        DeveBuscarEnderecoMkt: false
      },
      loadingList: false,
      pagination: {
        PageNumber: 1,
        RowsPerPage: 10,
        TotalItems: 0,
      },
      merchantMaquinaSelecionado: {
        Id: null,
        DataInicioOperacao: null,
        DataFimOperacao: null,
        Observacao: null,
        Situacao: {
          Id: null
        }
      },
      validateMerchantMaquina: false,
      listaMerchantMaquina: [],
      loadingModalVisualizarMerchantMaquina: false,
      loadingModal: false,
      MerchantMaquinaForm: false,
      merchantMaquina: {
        Id: null,
        DataFimOperacao: null,
        DataInicioOperacao: null,
        Motivo: null,
        Rotulo: null,
        IdentificadorTerminal: null,
        IdSituacao: null
      },
      merchantMaquinaClone: {
        Id: null,
        DataFimOperacao: null,
        DataInicioOperacao: null,
        Motivo: null,
        Rotulo: null,
        IdConta: null,
        IdEmpresa: null,
			  IdLoja: null,
			  IdTerminal: null,
        IdentificadorTerminal: null,
        Situacao: {
          Id: null
        },
        Maquina:
        {
          Id: null,
          Situacao:{
            Id: null
          }
        }
      },
      DeveBuscarEnderecoMkt: false,
      isSubaccount: false,
      isPfSubaccount: false
    };
  },
  computed: {},
  watch: {
    "pagination.PageNumber": function () {
      this.ListarMerchantMaquina();
    },
    "pagination.RowsPerPage": function () {
      this.ListarMerchantMaquina();
    },
  },
  mounted() {
    this.ListarMerchantMaquina();
  },
  methods: {
    VerificarSeJaExisteMerchantMaquina: function (){
      this.loadingAddUpdate = true;

      this.$store
        .dispatch("VerificarSeJaExisteMerchantMaquina", { idMerchant: this.infoMerchantMaquina.Merchant.Id })
        .then((response) => {
          if(response != null && response == false){
            this.showInputsMargemLucro = true;
            this.$makeToast(
                  "Nos casos em que os merchants ainda não tem nenhuma máquina vinculada as margens de lucro devem ser informadas para inclusão dos métodos de pagamento físicos.",
                  "info",
                  "Informação."
                );
          } else{
            this.showInputsMargemLucro = false;      
          }
        })
        .catch((error) => {
          this.$makeToast(
            undefined,
            "danger",
            "Erro ao verificar se o merchant em questão já possui alguma máquina vinculada.",
            error
          );
        })
        .finally(() => {
          this.loadingAddUpdate = false;
        });
    },
    BuscarMerchant: function () {
      this.loadingAddUpdate = true;
      this.$store
        .dispatch("GetMerchant", { id: this.infoMerchantMaquina.Merchant.Id })
        .then((response) => {
          if(response != null && response.Id > 0){
          this.infoMerchantMaquina.Merchant.Id = response.Id;
          this.infoMerchantMaquina.Merchant.Nome = response.Name;
          this.infoMerchantMaquina.Merchant.Documento = response.Identity;
          this.infoMerchantMaquina.Merchant.IdMerchantRoot = response.IdMerchantRoot;

          if (response.IdMerchantRoot) {
            this.isSubaccount = true;
            this.DeveBuscarEnderecoMkt = true;
            if (response.Identity.length <= 12){
              this.isPfSubaccount = true;
            } else {
                this.isPfSubaccount = false;
            }
        } else {
            this.isSubaccount = false;
            this.DeveBuscarEnderecoMkt = false;
            this.isPfSubaccount = false;

        }

          this.VerificarSeJaExisteMerchantMaquina();
          } else {
            this.$makeToast(
                  "Merchant não encontrado.",
                  "info",
                  "Informação."
                );
          }
          
        })
        .catch((error) => {
          this.$makeToast(
            undefined,
            "danger",
            "Erro ao obter as informações do cliente",
            error
          );
        })
        .finally(() => {
          this.loadingAddUpdate = false;
        });
    },
    SaveNewMerchantMaquina: function (wasEnterPressed) {
      this.validateMerchantMaquinaForm = true;

      this.$refs.validateMerchantMaquinaForm.validate().then(isValid => {
        if (isValid) {
          this.loadingAddUpdate = true;

          this.infoMerchantMaquina.DeveBuscarEnderecoMkt = this.DeveBuscarEnderecoMkt;

          this.$store.dispatch("ReservarMaquinas", this.infoMerchantMaquina)
            .then(() => {
              this.$makeToast("A reserva de máquinas para o merchant foi feita com sucesso.", "success", "Reserva efetuada.");
              this.ListarMerchantMaquina();
              this.$bvModal.hide("mFormMerchantMaquina");
            })
            .catch(error => {
              this.$makeToast(undefined, "danger", "Erro ao reservar as máquinas.", error);
            })
            .finally(() => {
              this.loadingAddUpdate = false;
              this.isSubaccount = false;
            });
        }
      });
    },

    EditarMerchantMaquina: function (e, i, view) {
      if (view == undefined && i != undefined) {
        // Edit
        this.IdMerchantMaquina = i;
        this.isSeeing = false;
        this.isEdit = true;
        this.GetMerchantMaquina(this.IdMerchantMaquina);
      } 
      this.$bvModal.show("mFormEditarMaquininha");
    },
    
    OpenMerchantMaquina: function (e, i, view) {
      if (e != undefined || e != null) {
        e.preventDefault();
      }
      this.validateMerchantMaquinaForm = false;
      this.ResetInfoMerchantMaquina();

      // Add new
      this.isSeeing = false;

      this.$bvModal.show("mFormMerchantMaquina");
    },
    OpenModalFilter: function () {
      this.$bvModal.show("mFilter");
    },
    GetIdMerchantRootClass: function (idMerchantRoot) {
      return idMerchantRoot == 0 ? "fas fa-minus" : "";
    },
    ResetInfoMerchantMaquina: function () {
      this.isSubaccount = false;
      this.isPfSubaccount = false;
      this.showInputsMargemLucro = false;
      this.infoMerchantMaquina = {
        Merchant: {
          Id: null
        },
        MargemLucroCredito: 0,
        MargemLucroDebito: 0,
        QuantidadeMaquinas: null,
        EhAntecipado: false,
        ModeloCaptura: 1
      };
    },
    Filter: function () { 
      this.$bvModal.hide("mFilter");
      this.ListarMerchantMaquina();
    },
    OpenModal(merchantMaquina) {
      if (merchantMaquina != null && merchantMaquina.Id > 0) {
        this.validateMerchantMaquina = false;

        this.merchantMaquinaSelecionado = null;
        this.loadingModalVisualizarMerchantMaquina = true;
        this.$bvModal.show("mVisualizarMerchantMaquina");
        this.merchantMaquinaSelecionado = JSON.parse(JSON.stringify(merchantMaquina));


        if (this.merchantMaquinaSelecionado.DataInicioOperacao != null && this.merchantMaquinaSelecionado.DataFimOperacao == null) {
          this.merchantMaquinaSelecionado.DataFimOperacao = new Date();
        }

        if (this.merchantMaquinaSelecionado.DataInicioOperacao == null) {
          this.merchantMaquinaSelecionado.DataInicioOperacao = new Date();
        }


        this.loadingModalVisualizarMerchantMaquina = false;
      }
    },
    IsAuthorizedShow: function () {
      return this.$isAuthorize("MerchantMaquina", "Update"); // ||
      // (this.$isAuthorize("Merchant", "List") && this.$isAuthorize("Merchant", "Get"))
    },
    LiberarBotaoIniciarOperacao(merchantMaquina) {
      var ret = false;

      if (merchantMaquina.UsuarioAtivacaoOperacao == null || merchantMaquina.UsuarioAtivacaoOperacao.Id < 1) ret = true;

      return ret;
    }, 
    DownloadPdf(merchantMaquina) {
      if(merchantMaquina.UrlPdfRotulo !== null){
        window.open(merchantMaquina.UrlPdfRotulo, "_blank");
      } else {
        this.$makeToast(
                  "Url do pdf não encontrada.",
                  "info",
                  "Informação."
                );
      }
      


    },
    BuscarClassSituacao(situacao) {

      let variation = "";
      if (situacao.Id == 1) {
        variation = "badge badge-info";
      } else if (situacao.Id == 2)  {
        variation = "badge badge-secondary";
      } else if (situacao.Id == 3)  {
        variation = "badge badge-warning";
      } else if (situacao.Id == 4)  {
        variation = "badge badge-success";
      } else if (situacao.Id == 5)  {
        variation = "badge badge-danger";
      }else if (situacao.Id == 6)  {
        variation = "badge badge-warning";
      }

      return variation;
   },
    LiberarBotaoFinalizarOperacao(merchantMaquina) {
      var ret = false;

      if (
        (merchantMaquina.UsuarioDesativacaoOperacao == null || merchantMaquina.UsuarioDesativacaoOperacao.Id < 1) &&
        merchantMaquina.UsuarioAtivacaoOperacao != null &&
        merchantMaquina.UsuarioAtivacaoOperacao.Id > 0
      )
        ret = true;

      return ret;
    },
    BuscarTitleVisualizarMaquinaMerchant() {
      if (this.merchantMaquinaSelecionado != null && this.merchantMaquinaSelecionado.Id > 0) {
        if (
          this.merchantMaquinaSelecionado.UsuarioAtivacaoOperacao != null &&
          this.merchantMaquinaSelecionado.UsuarioAtivacaoOperacao.Id > 0
        )
          return `Você tem certeza que deseja informar o fim de operação para o terminal de patrimônio <u>${this.merchantMaquinaSelecionado.Maquina.CodigoPatrimonio}</u> para o merchant <u>${this.merchantMaquinaSelecionado.Merchant.Name} </u>`;
        else
          return `Você tem certeza que deseja informar o início de operação para o terminal de patrimônio <u>${this.merchantMaquinaSelecionado.Maquina.CodigoPatrimonio}</u> para o merchant <u>${this.merchantMaquinaSelecionado.Merchant.Name} </u>`;
      } else return "";
    },
    AtualizarMerchantMaquina() {
      this.validateMerchantMaquina = true;

      this.$refs.MerchantMaquinaForm.validate().then((isValid) => {
        if (isValid) {
          this.$store
            .dispatch("UpdateMerchantMaquina", this.merchantMaquinaSelecionado)
            .then((response) => {
              if (response != null && !response.HasError) {
                this.$makeToast(
                  "Operação efetuada.",
                  "success",
                  "Sucesso!"
                );
                this.$bvModal.hide("mVisualizarMerchantMaquina");

              }
            })
            .catch((error) => {
              this.$makeToast(undefined, "danger", "Erro ao listar os vinculos entre merchants e máquinas.", error);
            })
            .finally(() => this.ListarMerchantMaquina());
        }
        else
          console.log('123123')
      });
    },
    LiberarBotaoAbrirPdf: function (merchantMaquina) {
      return (merchantMaquina.Situacao !== null && merchantMaquina.Situacao.Id !== 1);
    },
    
    BloquearData: function (merchantMaquina) {
      return (merchantMaquina.Situacao !== null && merchantMaquina.Situacao.Id !== 1);
    },
    
    ListarMerchantMaquina: function () { 
      this.countFilter = 0;
      if (hasValue(this.filter.IdMerchant)) this.countFilter++;
      if (hasValue(this.filter.DocumentoMerchant)) this.countFilter++;
      if (hasValue(this.filter.NomeMerchant)) this.countFilter++;
      if (hasValue(this.filter.CodigoPatrimonioMaquina)) this.countFilter++;
      if (hasValue(this.filter.NumeroSerieMaquina)) this.countFilter++;
      if (hasValue(this.filter.IdSituacao)) this.countFilter++;
      if (hasValue(this.filter.IdTerminal)) this.countFilter++;
      if (hasValue(this.filter.IdLoja)) this.countFilter++;
      if (hasValue(this.filter.IdEmpresa)) this.countFilter++;
      if (hasValue(this.filter.IdMaquininha)) this.countFilter++;
     
      

      this.loadingList = true;
      let data = {
        ...this.pagination,
        ...{
          "Object.IdMerchant": this.filter.IdMerchant,
          "Object.DocumentoMerchant": this.filter.DocumentoMerchant,
          "Object.NomeMerchant": this.filter.NomeMerchant,
          "Object.CodigoPatrimonioMaquina": this.filter.CodigoPatrimonioMaquina,
          "Object.NumeroSerieMaquina": this.filter.NumeroSerieMaquina,
          "Object.IdSituacao": this.filter.IdSituacao,
          "Object.IdTerminal": this.filter.IdTerminal,
          "Object.IdLoja": this.filter.IdLoja,
          "Object.IdEmpresa": this.filter.IdEmpresa,
          "Object.IdMaquininha": this.filter.IdMaquininha,

        },
      };
      delete data.TotalItems;
      this.$store
        .dispatch("ListMerchantMaquina", data)
        .then((response) => {
          if (response != null && !response.HasError) {
            this.listaMerchantMaquina = response.Objects;
            this.pagination.TotalItems = response.TotalItems;
          }
        })
        .catch((error) => {
          this.$makeToast(undefined, "danger", "Erro ao listar os vinculos entre merchants e máquinas.", error);
        })
        .finally(() => (this.loadingList = false));
    },
    ResetFilter: function () {
      (this.filter = {
        IdMerchant: null,
        NomeMerchant: null,
        DocumentoMerchant: null,
        CodigoPatrimonioMaquina: null,
        NumeroSerieMaquina: null,
        IdSituacao: null,
        IdTerminal: null, 
        IdEmpresa: null, 
        IdLoja: null, 
        IdMaquininha: null, 
      }),
        this.ListarMerchantMaquina();
    },
    SalvarEditarMerchantMaquina: function (merchantMaquinaClone) {
    console.log(merchantMaquinaClone);
      this.MerchantMaquinaForm = true;
      this.$refs.validateFormEditarMaquininha.validate().then((isValid) => {
        if (isValid) {
          this.$store
            .dispatch("UpdateMerchantMaquinaSituacao", this.merchantMaquinaClone)
            .then((response) => {
              if (response != null && !response.HasError) {
                this.$makeToast(
                  "Operação efetuada.",
                  "success",
                  "Sucesso!"
                );
                this.$bvModal.hide("mFormEditarMaquininha");

              }
            })
            .catch((error) => {
              this.$makeToast(undefined, "danger", "Erro ao listar os vinculos entre merchants e máquinas.", error);
            })
            .finally(() => this.ListarMerchantMaquina());
        }
      });
    },
    GetMerchantMaquina: function (id) {
      this.merchantMaquinaClone = null;
      this.loadingMerchant = true;
      this.$store
        .dispatch("GetMerchantMaquina", { id: id })
        .then((response) => {
          this.merchantMaquina = response;
          this.merchantMaquinaClone = this.merchantMaquina;
        })
        .catch((error) => {
          this.$makeToast(undefined, "danger", "Erro ao obter as informações do cliente", error);
        })
        .finally(() => {
          this.loadingMerchant = false;
        });
    },
  },
};
</script>

<style scoped>
.fa-red {
  color: #ff0000;
}

/* .table thead tr th {
  text-align:left
}
.table tbody tr td {
  white-space: pre-wrap;
  text-align:left
} */
</style>


// WEBPACK FOOTER //
// src/components/pages/Maquina/MerchantMaquina.vue